import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { NewLearningResourceRequestDialogComponent } from 'src/app/components/main/employees/top-menu-employee/new-learning-resource-request-dialog/new-learning-resource-request-dialog.component';
import { LearningResourceUserFormationProfileComponent } from 'src/app/components/main/shared/learning-resource-user-formation-profile/learning-resource-user-formation-profile.component';
import { User } from 'src/app/models/user.model';
import { ApiService } from 'src/app/services';

@Component({
  selector: 'app-upskilling-formations-tab',
  templateUrl: './upskilling-formations-tab.component.html',
  styleUrl: './upskilling-formations-tab.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, RouterLink, LearningResourceUserFormationProfileComponent],
})
export class UpskillingFormationsTabComponent implements OnInit {
  private readonly api_service = inject(ApiService);
  private readonly destroy_ref = inject(DestroyRef);
  private readonly mat_dialog = inject(MatDialog);

  private readonly formation_profile = viewChild(LearningResourceUserFormationProfileComponent);

  readonly current_user = signal<User | null>(null);

  ngOnInit(): void {
    this.api_service
      .me()
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe({
        next: (user: User): void => {
          this.current_user.set(user);
        },
      });
  }

  openRequestDialog(): void {
    const dialog_ref = this.mat_dialog.open(NewLearningResourceRequestDialogComponent, {
      width: '520px',
      minWidth: '400px',
    });

    dialog_ref
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe((): void => {
        this.formation_profile()?.reload();
      });
  }
}
